import { financeAPI } from "../../axios";

export const actions = {
    createSLTypeCategory(context, data) {
        return financeAPI.post(`SubsidiaryLedgerTypeCategory/Create`, data);
    },
    getSLTypeCategories(context) {
        return financeAPI.get(`SubsidiaryLedgerTypeCategory/All`);
    },
    getSingleSLTypeCategory(context, id) {
        return financeAPI.get(`SubsidiaryLedgerTypeCategory/${id}`);
    },
    removeSLTypeCategory(context, categoryId) {
        return financeAPI.delete(`SubsidiaryLedgerTypeCategory/Remove/${categoryId}`);
    },
    updateSLTypeCategory(context, data) {
        return financeAPI.put(`SubsidiaryLedgerTypeCategory/Update/${data.id}`, data);
    },
}